export const origins = {
  ORIGIN_UNKNOWN: 0,
  ORIGIN_DIRECT: 1,
  ORIGIN_ORGANIC: 2,
  ORIGIN_PAID_PUBLISHERS: 3,
  ORIGIN_PAID_RTB: 4,
  ORIGIN_MOBILEAPP_IPHONE: 5,
  ORIGIN_MOBILEAPP_ANDROID: 6,
  ORIGIN_MOBILEAPP_OTHERS: 7,
  ORIGIN_RSS: 9,
  ORIGIN_PAID_CRITEO: 10,
  ORIGIN_PAID_ADWORDS: 11,
  ORIGIN_PAID_FACEBOOK: 12,
  ORIGIN_PAID_BING: 13,
  ORIGIN_ALERT_NORMAL: 15,
  ORIGIN_ALERT_DECREASE: 16,
  ORIGIN_ALERT_MORELIKETHIS: 17,
  ORIGIN_ALERT_NEWSLETTER: 18,
  ORIGIN_PAID_DSA: 20,
  ORIGIN_PAID_ADWORDS_DISPLAY: 21,
  ORIGIN_PAID_FACEBOOK_DISPLAY: 22,
  ORIGIN_MOBILEAPP_IPHONE_PUSH: 27,
  ORIGIN_MOBILEAPP_ANDROID_PUSH: 28,
  ORIGIN_ALERT_DIGEST_DECREASE_PRICE: 31,
  ORIGIN_ALERT_REFINE: 32,
  ORIGIN_MOBILEAPP_IPHONE_SALE: 33,
  ORIGIN_MOBILEAPP_IPHONE_RENT: 34,
  ORIGIN_ALERT_WELCOME: 36,
  ORIGIN_MOBILEAPP_ANDROID_SALE: 37,
  ORIGIN_MOBILEAPP_ANDROID_RENT: 38,
  ORIGIN_MOBILEAPP_IPHONE_PUSH_MAP: 42,
  ORIGIN_MOBILEAPP_IPHONE_PUSH_FILTERS: 43,
  ORIGIN_MOBILEAPP_ANDROID_PUSH_FILTERS: 44,
  ORIGIN_PUBLISHERS_API: 45,
  ORIGIN_PAID_ROCKET: 47,
  ORIGIN_MOBILEAPP_IPHONE_PUSH_SIMILAR_ADS: 48,
  ORIGIN_MOBILEAPP_ANDROID_PUSH_SIMILAR_ADS: 49,
  ORIGIN_ALERT_NORMAL2: 51,
  ORIGIN_ALERT_MORELIKETHIS2: 53,
  ORIGIN_PAID_JOT: 54,
  ORIGIN_MOBILEAPP_IPHONE_PUSH_ADS_RELAXED_FILTERS: 55,
  ORIGIN_MOBILEAPP_ANDROID_PUSH_ADS_RELAXED_FILTERS: 56,
  ORIGIN_PAID_BING_JOT: 57,
  ORIGIN_PAID_YANDEX_JOT: 58,
  ORIGIN_MOBILEAPP_IPHONE_PUSH_CLEANED_FILTERS: 59,
  ORIGIN_MOBILEAPP_ANDROID_PUSH_CLEANED_FILTERS: 60,
  ORIGIN_MOBILEAPP_IPHONE_PUSH_REMOVE_WHAT: 61,
  ORIGIN_MOBILEAPP_ANDROID_PUSH_REMOVE_WHAT: 62,
  ORIGIN_BROWSER_NOTIFICATION: 63,
  ORIGIN_ALERT_ALREADY_FOUND: 64,
  ORIGIN_PAID_NEW_BUILDINGS: 65,
  ORIGIN_ALERT_ON_BOARDING: 66,
};



// WEBPACK FOOTER //
// ./app/common/constants/origins.js